
export default function () {

	$(function () {
		$.validator.addMethod(
			"ValidaSelect",
			function (value, element) {

				if ($("#select-form").val() === "") {
					return false;
				} else {
					return true;
				}
			}
		);
	});

	$(".form-validate").each(function () {
		$(this).validate({
			rules: {
				name: {
					required: true,
					minlength: 3
				},
				phone: {
					required: true,
					minlength: 14
				},
				email: {
					required: true,
					email: true
				},
				message: {
					required: true,
					minlength: 3
				},
				terms:{
					required: true,
				},
				password: {
					required: true,
					minlength: 3
				},
				'ValidaSelect': {
					required: true
				}
			},
			messages: {
				name: {
					required: "Por favor, informe seu nome",
					minlength: "O nome deve ter pelo menos 3 caracteres"
				},
				phone: {
					required: "Por favor, informe seu telefone",
					minlength: "O telefone deve ter DDD e número válido"
				},
				email: {
					required: "É necessário informar um e-mail",
					email: "É necessário informar um e-mail válido",
				},
				message: {
					required: "Campo obrigatório",
					minlength: "O campo deve ter pelo menos 3 caracteres"
				},
				terms:{
					required: "Campo obrigatório"
				},
				password: {
					required: "Por favor, preencha o campo senha",
					minlength: "O nome deve ter pelo menos 3 caracteres"
				},
				'ValidaSelect': {
					required: "Campo obrigatório"
				}
			}
		});
	});
}